var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5171 11.7805H11.7809V18.5167H18.5171V11.7805Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73617 6.73608H0V13.4723H6.73617V6.73608Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 16.8682H23.264V23.6043H30.0002V16.8682Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4721 0H6.73596V6.73617H13.4721V0Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2637 23.6057H16.5275V30.3419H23.2637V23.6057Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2637 0H16.5275V6.73617H23.2637V0Z",
    fill: "#946D42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4721 23.6057H6.73596V30.3419H13.4721V23.6057Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 6.73608H23.264V13.4723H30.0002V6.73608Z",
    fill: "#946D42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73617 16.8682H0V23.6043H6.73617V16.8682Z",
    fill: "black",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductImage);
export default __webpack_public_path__ + "static/media/product-image.f6b25bffdfbc09212c0a7b0c2c4f1ee3.svg";
export { ForwardRef as ReactComponent };